import { render } from "./Magazines.vue?vue&type=template&id=1aff99da"
import script from "./Magazines.vue?vue&type=script&lang=js"
export * from "./Magazines.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__